import React from 'react';

import RichText from 'components/RichText/RichText';
import { ColorPicker } from 'components/ui/ColorPicker/color-picker';
import UploadImage from 'components/UploadImage/UploadImage';

import { CheckoutDesignTabProps } from '../types';

const CheckoutDesignTab: React.FC<CheckoutDesignTabProps> = ({
  formikProps
}) => {
  const { handleChange, values, setFieldValue } = formikProps;

  return (
    <div className="w-[456px] mx-auto">
      <RichText
        title="Checkout Design"
        description="Personalize your payment button, adding your logo, background image, and font color."
        className="mb-9"
      />
      <div className="flex flex-col gap-5 mb-4">
        <UploadImage
          className="w-full"
          title="Logo"
          description="Add your logo to the checkout header"
          buttonText="Upload"
          selectedImageUrl={values.logo}
          onUpload={(url: string) => {
            handleChange(url);
          }}
          isRequired={true}
        />
        <div className="grid grid-cols-2 gap-9 w-full max-w-[920px]">
          <ColorPicker
            label="Primary Color"
            onChange={(value) => setFieldValue('primaryColor', value)}
            defaultValue={values.primaryColor}
          />

          <ColorPicker
            label="Font Color"
            onChange={(value) => setFieldValue('textColor', value)}
            defaultValue={values.textColor}
          />

          <ColorPicker
            label="Button Color"
            onChange={(value) => setFieldValue('buttonColor', value)}
            defaultValue={values.buttonColor}
          />

          <ColorPicker
            label="Button Font Color"
            onChange={(value) => setFieldValue('buttonTextColor', value)}
            defaultValue={values.buttonTextColor}
          />
        </div>
        <UploadImage
          className="w-full"
          title="Background Image (Mobile)"
          description="1:2 (vertical) aspect ratio with at least 400px width"
          buttonText="Upload"
          selectedImageUrl={values.mobileBgImage}
          onUpload={(url: string) => {
            handleChange({ target: { name: 'mobileBgImage', value: url } });
          }}
        />
        <UploadImage
          className="w-full"
          title="Background Image (Desktop)"
          description="1:2 (vertical) aspect ratio with at least 400px width"
          buttonText="Upload"
          selectedImageUrl={values.backgroundImage}
          onUpload={(url: string) => {
            handleChange({ target: { name: 'backgroundImage', value: url } });
          }}
        />
      </div>
    </div>
  );
};

export default CheckoutDesignTab;
